const state = {
  verifiedUsers: [],
  referralCodes: [],
  dateOfBirth: [],
  workStatus: [],
  userServicesVerified: [],
  userServices: [],
  userServicesPrice: [],
  location: [],
  locationCity: [],
  orders: [],
  ordersCrs: [],
  paymentTypes: [],
  paymentTypesAmounts: [],
  serviceSearch: [],
  serviceSearchColumns: [],
  verifiedUsersColumns: [],
  referralCodesColumns: [],
  dateOfBirthColumns: [],
  workStatusColumns: [],
  userServicesVerifiedColumns: [],
  userServicesColumns: [],
  userServicesPriceColumns: [],
  locationColumns: [],
  locationCityColumns: [],
  ordersColumns: [],
  ordersCrsColumns: [],
  paymentTypesColumns: [],
  paymentTypesAmountsColumns: [],
  userServicesInSpecifiedCityReport: [],
  totalUsersAndUserServiceReport: [],
  promotionalCodesReport: [],
  ordersRejectionReport: [],
  userRegulationsReport: [],
  usersActivityReport: [],
  adminPermissionSettingsReport: [],
  rechargesReport: [],
  walletBalancesReport: [],
  profileFeaturesReport: [],
  languagesReport: [],
  trainingsReport: [],
  cvsReport: [],
  serviceRegulationsReport: [],
  smsReport: [],
  usersAndOrdersReport: [],
  ordersByStatusReport: [],
  usersServicesByCityReport: [],
  usersReportsFromAppReport: [],
  dodBillsReport: [],
  invoicesReport: [],
  databaseTables: [],
  sqlGeneratedReport: [],
  sqlReportNote: ""
};
const mutations = {
  SET_DATABASE_TABLES(state, tables) {
    state.databaseTables = tables;
  },
  SET_SQL_REPORT(state, report) {
    state.sqlGeneratedReport = report;
  },
  SET_PROFILE_FEATURES_REPORT(state, report) {
    state.profileFeaturesReport = report;
  },
  SET_LANGUAGES_REPORT(state, report) {
    state.languagesReport = report;
  },
  SET_TRAININGS_REPORT(state, report) {
    state.trainingsReport = report;
  },
  SET_CVS_REPORT(state, report) {
    state.cvsReport = report;
  },
  SET_ORDERS_REJECTION_REPORT(state, report) {
    state.ordersRejectionReport = report;
  },
  SET_PROMOTIONAL_CODES_REPORT(state, report) {
    state.promotionalCodesReport = report;
  },
  SET_TOTAL_USERS_AND_USER_SERVICES_REPORT(state, report) {
    state.totalUsersAndUserServiceReport = report;
  },
  SET_USER_SERVICES_IN_SPECIFIED_CITY_REPORT(state, report) {
    state.userServicesInSpecifiedCityReport = report;
  },
  SET_VERIFIED_USERS_REPORT(state, report) {
    state.verifiedUsers = report;
    state.verifiedUsersColumns = report.length > 0 ? report[0].results : [];
  },
  SET_REFERRAL_CODES_REPORT(state, codes) {
    state.referralCodes = codes;
    state.referralCodesColumns = codes.length > 0 ? codes[0].results : [];
  },
  SET_DATE_OF_BIRTH_REPORT(state, report) {
    state.dateOfBirth = report;
    state.dateOfBirthColumns = report.length > 0 ? report[0].results : [];
  },
  SET_WORK_STATUS_REPORT(state, report) {
    state.workStatus = report;
    state.workStatusColumns = report.length > 0 ? report[0].results : [];
  },
  SET_USER_SERVICES_REPORT(state, report) {
    state.userServices = report;
    state.userServicesColumns = report.length > 0 ? report[0].results : [];
  },
  SET_SERVICE_SEARCH_REPORT(state, report) {
    state.serviceSearch = report;
    state.serviceSearchColumns = report.length > 0 ? report[0].results : [];
  },
  SET_USER_SERVICES_VERIFIED_REPORT(state, report) {
    state.userServicesVerified = report;
    state.userServicesVerifiedColumns =
      report.length > 0 ? report[0].results : [];
  },
  SET_USER_SERVICES_PRICE_REPORT(state, report) {
    (state.userServicesPrice = report),
      (state.userServicesPriceColumns =
        report.length > 0 ? report[0].results : []);
  },
  SET_LOCATION_REPORT(state, report) {
    state.location = report;
    state.locationColumns = report.length > 0 ? report[0].results : [];
  },
  SET_LOCATION_CITY_REPORT(state, report) {
    state.locationCity = report;
    state.locationCityColumns = report.length > 0 ? report[0].results : [];
  },
  SET_ORDERS_REPORT(state, report) {
    state.orders = report;
    state.ordersColumns = report.length > 0 ? report[0].results : [];
  },
  SET_ORDERS_CRS_REPORT(state, report) {
    state.ordersCrs = report;
    state.ordersCrsColumns = report.length > 0 ? report[0].results : [];
  },
  SET_PAYMENT_TYPES_REPORT(state, report) {
    state.paymentTypes = report;
    let columns = [];
    let length = 0;
    report.forEach((element) => {
      if (Object.values(element.results).length >= length) {
        columns = element.results;
        length = Object.values(element.results).length;
      }
    });

    state.paymentTypesColumns = columns;
  },
  SET_PAYMENT_TYPES_AMOUNTS_REPORT(state, report) {
    state.paymentTypesAmounts = report;
    let columns = [];
    let length = 0;
    report.forEach((element) => {
      if (Object.values(element.results).length >= length) {
        columns = element.results;
        length = Object.values(element.results).length;
      }
    });

    state.paymentTypesAmountsColumns = columns;
  },
  SET_USER_REGULATIONS_REPORT(state, report) {
    state.userRegulationsReport = report;
  },
  SET_SERVICE_REGULATIONS_REPORT(state, report) {
    state.serviceRegulationsReport = report;
  },
  SET_USERS_ACTIVITY_REPORT(state, report) {
    state.usersActivityReport = report;
  },

  SET_ADMIN_PERMISSION_SETTINGS_REPORT(state, report) {
    state.adminPermissionSettingsReport = report;
  },

  SET_RECHARGES_REPORT(state, report) {
    state.rechargesReport = report;
  },

  SET_WALLET_BALANCES_REPORT(state, report) {
    state.walletBalancesReport = report;
  },

  SET_SMS_REPORT(state, report) {
    state.smsReport = report;
  },
  SET_USERS_AND_ORDERS_REPORT(state, report) {
    state.usersAndOrdersReport = report;
  },
  SET_ORDERS_BY_STATUS_REPORT(state, report) {
    state.ordersByStatusReport = report;
  },
  SET_USERS_SERVICES_BY_CITY_REPORT(state, report) {
    state.usersServicesByCityReport = report
  },
  SET_USERS_REPORTS_FROM_APP_REPORT(state, report) {
    state.usersReportsFromAppReport = report
    state.usersServicesByCityReport = report;
  },
  SET_DOD_BILLS_REPORT(state, report) {
    state.dodBillsReport = report;
  },
  SET_INVOICES_REPORT(state, report) {
    state.invoicesReport = report;
  },
  // Scala wynik weryfikacji z Fakturownią po orderId (tylko trafienia): uzupełnia numer faktury,
  // a faktury wystawione ręcznie (istnieją w Fakturowni, brak wpisu w bazie) oznacza jako PRZESŁANE.
  MERGE_INVOICES_VERIFY(state, verifyResults) {
    const byOid = {};
    (verifyResults || []).forEach(v => {
      if (v && v.orderId && v.existsInFakturownia) byOid[v.orderId.toLowerCase()] = v;
    });
    state.invoicesReport = (state.invoicesReport || []).map(row => {
      const v = row.orderId ? byOid[row.orderId.toLowerCase()] : null;
      if (!v) return row;
      const merged = { ...row };
      if (v.invoiceNumber) merged.invoiceNumber = v.invoiceNumber;
      if (v.pdfUrl) merged.pdfUrl = v.pdfUrl;
      if (v.invoiceId != null) merged.invoiceId = v.invoiceId;
      if (merged.status === "NIEWYSTAWIONA") {
        merged.status = "PRZESLANO";
        merged.statusLabel = "PRZESŁANO";
        merged.note = "wystawiona ręcznie";
      }
      merged.verified = true;
      return merged;
    });
  },
  SET_SQL_REPORT_NOTE(state, note) {
    state.sqlReportNote = note
  }
};
const getters = {
  getSqlReport: (state) => {
    return state.sqlGeneratedReport;
  },
  getDatabaseTables: (state) => {
    return state.databaseTables;
  },
  getPromotionalCodesReport: (state) => {
    return state.promotionalCodesReport;
  },
  getTotalUsersAndUserServiceReport: (state) => {
    return state.totalUsersAndUserServiceReport;
  },
  getUserServicesInSpecifiedCityReport: (state) => {
    return state.userServicesInSpecifiedCityReport;
  },
  getVerifiedUsersReport: (state) => {
    return state.verifiedUsers;
  },
  getVerifiedUsersColumns: (state) => {
    return state.verifiedUsersColumns;
  },
  getReferralCodesReport: (state) => {
    return state.referralCodes;
  },
  getReferralCodesColumns: (state) => {
    return state.referralCodesColumns;
  },

  getDateOfBirthReport: (state) => {
    return state.dateOfBirth;
  },
  getDateOfBirthColumns: (state) => {
    return state.dateOfBirthColumns;
  },

  getWorkStatusReport: (state) => {
    return state.workStatus;
  },
  getWorkStatusColumns: (state) => {
    return state.workStatusColumns;
  },

  getUserServicesVerifiedReport: (state) => {
    return state.userServicesVerified;
  },
  getUserServicesVerifiedColumns: (state) => {
    return state.userServicesVerifiedColumns;
  },

  getUserServicesReport: (state) => {
    return state.userServices;
  },
  getUserServicesColumns: (state) => {
    return state.userServicesColumns;
  },

  getServiceSearchReport: (state) => {
    return state.serviceSearch;
  },
  getServiceSearchColumns: (state) => {
    return state.serviceSearchColumns;
  },

  getUserServicesPriceReport: (state) => {
    return state.userServicesPrice;
  },
  getUserServicesPriceColumns: (state) => {
    return state.userServicesPriceColumns;
  },

  getLocationReport: (state) => {
    return state.location;
  },
  getLocationColumns: (state) => {
    return state.locationColumns;
  },

  getLocationCityReport: (state) => {
    return state.locationCity;
  },
  getLocationCityColumns: (state) => {
    return state.locationCityColumns;
  },

  getOrdersReport: (state) => {
    return state.orders;
  },
  getOrdersColumns: (state) => {
    return state.ordersColumns;
  },

  getOrdersCrsReport: (state) => {
    return state.ordersCrs;
  },
  getOrdersCrsColumns: (state) => {
    return state.ordersCrsColumns;
  },

  getPaymentTypesReport: (state) => {
    return state.paymentTypes;
  },
  getPaymentTypesAmountsReport: (state) => {
    return state.paymentTypesAmounts;
  },
  getPaymentTypesColumns: (state) => {
    return state.paymentTypesColumns;
  },
  getPaymentTypesAmountsColumns: (state) => {
    return state.paymentTypesAmountsColumns;
  },
  getOrdersRejectionReport: (state) => {
    return state.ordersRejectionReport;
  },
  getUserRegulationsReport: (state) => {
    return state.userRegulationsReport;
  },
  getServiceRegulationsReport: (state) => {
    return state.serviceRegulationsReport;
  },
  getUsersActivityReport: (state) => {
    return state.usersActivityReport;
  },
  getAdminPermissionSettingsReport: (state) => {
    return state.adminPermissionSettingsReport;
  },
  getRechargesReport: (state) => {
    return state.rechargesReport;
  },
  getWalletBalancesReport: (state) => {
    return state.walletBalancesReport;
  },
  getProfileFeaturesReport: (state) => {
    return state.profileFeaturesReport;
  },
  getLanguagesReport: (state) => {
    return state.languagesReport;
  },
  getTrainingsReport: (state) => {
    return state.trainingsReport;
  },
  getCvsReport: (state) => {
    return state.cvsReport;
  },
  getSmsReport: state => state.smsReport,
  getUsersAndOrdersReport: state => state.usersAndOrdersReport,
  getOrdersByStatusReport: state => state.ordersByStatusReport,
  getUsersServicesByCityReport: state => state.usersServicesByCityReport,
  getUsersReportsFromAppReport: state => state.usersReportsFromAppReport,
  getDodBillsReport: state => state.dodBillsReport,
  getInvoicesReport: state => state.invoicesReport,
  getSqlReportNote: state => state.sqlReportNote
};

export default {
  state,
  mutations,
  getters,
};
